<script>
  import PortfolioWorkItem from '../portfolio/work/Item.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let featured;
  let grow = false;
</script>

<div
  class="single-featured container"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  {#if featured.logo}
    <img
      class="single-featured__logo"
      src={featured.logo.src}
      width={featured.logo.width}
      height={featured.logo.height}
      alt={featured.logo.alt}
      loading="lazy"
    />
  {/if}
  <PortfolioWorkItem item={featured.item} />
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .single-featured {
    margin: 0 auto;
    padding-top: 10rem;

    @include resp-max('s') {
      padding-top: 0;
      padding-bottom: 14rem;
    }
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__logo {
      margin: 0 auto 5rem;

      @include resp-max('s') {
        margin: 0 auto 3rem;
      }
    }
  }
</style>
